import React from "react";

import Error from "../../../../../assets/images/perspectives/error.svg?react";
import { FullCenterViewLayout, type FullCenterViewLayoutProps } from "../full-center-view-layout/FullCenterViewLayout";

type DataErrorProps = Omit<FullCenterViewLayoutProps, "image" | "content">;

export const DataError: React.FC<React.PropsWithChildren<DataErrorProps>> = ({ children, ...props }) => (
	<FullCenterViewLayout
		content={children}
		image={
			<div className="h-[144px] max-h-full w-[321px] max-w-full">
				<Error className="h-full w-full" />
			</div>
		}
		{...props}
	/>
);
